import React, { useEffect, useState } from "react";
import {
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBTableFoot,
  MDBCard,
  MDBCardBody,
} from "mdbreact";
import {
  Button,
  CardBody,
  Container,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  FormGroup,
  Col,
  Card,
  CardTitle,
  CardText,
  Row,
  Table,
} from "reactstrap";
import useGetAuthed from "../../helpers/hooks/useGetAuthed";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import ReactTooltip from "react-tooltip";
import toastr from "toastr";
import usePutAuthed from "../../helpers/hooks/usePutAuthed";
import moment from "moment";
import usePostAuthed from "../../helpers/hooks/usePostAuthed";
import FarmerProfileModal from "./Modals/FarmerProfileModal";
import StaticaDataModal from "./Modals/StaticDataModal";
import GovtDataModal from "./Modals/GovtDataModal";
import AgronomicsModal from "./Modals/AgronomicsModal";
import CropSaleModal from "./Modals/CropSaleModal";
import CropInsuranceData from "./Modals/CropInsuranceDataModal";
import SocialDataModal from "./Modals/SocialDataModal";
function LoanAnalytics() {
  // get loanId and id
  // const loanId = 'وہا-b35f-1'
  // const id = '653f836708f5805712b1af04'

  // states
  const { loanId, id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [analytics, setAnaltics] = useState("");
  const [userInformation, setUserInformation] = useState([]);
  const [loan, setLoan] = useState("");
  const [modal, setModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  const [comment, setComment] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalComment, setModalComment] = useState("");
  const [reviewModal, setReviewModal] = useState(false);

  // ... rest of your component code ...

  // const [criteriaModal, setCriteriaModal] = useState(false)

  const handleDisable = () => {
    setIsDisable(!isDisable);
  };
  console.log("Comment to be :", comment);
  console.log(id);
  console.log(loanId, typeof loanId);
  console.log(+userInformation[0]?.loan_application?.preferred_loan_amount);

  // hooks
  const [data, error, loading, call] = useGetAuthed(
    `get_loan_analytics/${loanId}`,
    true,
    "loan"
  );
  const [userData, userError, userLoading, userCall] = useGetAuthed(
    `get_loan_application/${loanId}`,
    true,
    "loan"
  );
  const [statusCall, statusData, statusError, statusLoading] = usePutAuthed(
    `update_loan_application/${id}`,
    "loan"
  );

  const [approveCall, approveData, approveError, approveLoading] =
    usePostAuthed("approve_loan", "loan");

  const [rejectCall, rejectData, rejectError, rejectLoading] = usePostAuthed(
    `reject_loan/?loan_id=${loanId}&loan_status=-1`,
    "loan"
  );

  const [reviewCall, reviewData, reviewError, reviewLoading] = usePostAuthed(
    `review_loan/?loan_id=${loanId}&loan_status=3`,
    "loan"
  );

  // EDITED BY

  // const [rejectCall, rejectData, rejectError, rejectLoading] = usePutAuthed(
  // `reject_loan/?loan_id=${loanId}&loan_status=-1`,
  // "loan"
  // );

  // EDITED BY

  const [modalCriteria, setModalCriteria] = useState({
    bool: false,
    criteriaName: null,
  });

  const history = useHistory();

  console.log(userData);

  // check bankAdmin token
  const bankAdmin = JSON.parse(localStorage.getItem("bankAdmin"));
  // console.log(bankAdmin)
  // loan statuses
  const loanStatus = [
    "Rejected By Bank",
    "Rejected By Beythak",
    "Pending Beythak Approval",
    "Pending Bank Approval",
    "Approved By Bank",
    "Under Review",
  ];

  // functions
  const toggleCriteria = (name = null) => {
    console.log(name);
    setModalCriteria({ bool: !modalCriteria.bool, criteriaName: name });
  };

  const toggleApprove = (e) => {
    setModal(!modal);
  };

  const toggleReview = () => {
    setReviewModal(!reviewModal);
  };

  const underReview = (e) => {
    toggleReview();
    reviewCall({
      loan_id: loanId,
      loan_status: e.target.value,
    }).then(() =>
      userCall().then(() => {
        toastr.success("Application has gone for under review");
        history.push(bankAdmin ? "/loan-list-bank" : "/loan-list/All");
      })
    );
    // setIsLoading(false);
  };

  const approve = () => {
    toggleApprove();
    console.log("Comment to be sent with approval:", comment);
    approveCall({
      loan_id: loanId,
      loan_status: bankAdmin ? 2 : 1,
      approved_amount:
        +userInformation[0]?.loan_application?.preferred_loan_amount,
      comment: comment,
    }).then(() =>
      userCall().then(() => {
        toastr.success("Application has been Approved");
        history.push(bankAdmin ? "/loan-list-bank" : "/loan-list/All");
      })
    );
    // setIsLoading(false);
  };

  const toggleReject = () => {
    setRejectModal(!rejectModal);
  };

  // const reject = async (e) => {
  // const statusUpdate = { ...loan, loan_status: e.target.value };
  // // const statusUpdate = {loan_status: e.target.value };
  // toggleReject();
  // console.log({ statusUpdate });
  // statusCall({ ...statusUpdate }).then(() => {
  // userCall().then(() => toastr.error("Application has been Rejected"));
  // });
  // setIsLoading(false);
  // };

  // EDITED BY

  const reject = async (e) => {
    // console.log("Comment to be rejected:", comment);

    toggleReject();
    rejectCall({
      loan_id: loanId,
      loan_status: bankAdmin ? -2 : -1,
      approved_amount:
        +userInformation[0]?.loan_application?.preferred_loan_amount,
      comment: comment,
    }).then(() => {
      userCall().then(() => toastr.error("Application has been Rejected"));
      history.push(bankAdmin ? "/loan-list-bank" : "/loan-list/All");
    });

    // setIsLoading(false);
  };
  // console.log("Comment to be rejected:", comment);
  // console.log("Comment to be rejected:", reject);
  // console.log("Comment to be rejected:", rejectCall);

  useEffect(() => {
    if (data) {
      console.log(data);
      setAnaltics(data);
      setIsLoading(true);
    }
    if (error) {
      toastr.error(error.detail);
    }
  }, [data, error]);

  useEffect(() => {
    // console.log(userData)
    if (!userLoading && userData && userData.length > 0) {
      console.log(userData);
      setUserInformation(userData);
      setLoan(userData[0].loan_application);
      console.log(userData);
      setIsLoading(true);
      if (loan?.loan_id !== loanId) {
        userCall();
        call();
      }
    }
  }, [userLoading, userData, loanId]);

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  function scrollToTable(x) {
    const tableElement = document.getElementById(`table_${x}`);
    if (tableElement) {
      const offset = 340; // Adjust this value to control the offset
      const topPos =
        tableElement.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: topPos, left: 0, behavior: "smooth" });
    }
  }

  return (
    <React.Fragment>
      <Container fluid>
        <div className="page-content">
          {/* buttons for beythak Admin */}
          {+userInformation[0]?.loan_application?.loan_status === 0 && (
            <div className="align-items-end d-flex justify-content-end mb-4">
              <Button
                className="mr-1"
                color="none"
                style={{
                  background: "#e4f7f1",
                  color: "rgb(00, 100, 0)",
                  padding: "10px",
                  fontSize: "0.8rem",
                }}
                onClick={toggleApprove}
                value={1}
              >
                Approve
              </Button>
              <Button
                color="none"
                style={{
                  background: "rgb(251,231,233)",
                  color: "rgb(224,109,110)",
                  padding: "10px",
                  fontSize: "0.8rem",
                }}
                onClick={toggleReject}
                value={-1}
              >
                Reject
              </Button>
            </div>
          )}

          {/* Modal for approved application */}
          <Modal isOpen={modal} toggle={toggleApprove}>
            <ModalHeader toggle={toggleApprove}>
              Approved Application
            </ModalHeader>

            <ModalBody>
              <Label className="CustomLabel">Loan Amount:</Label>{" "}
              <Label>
                {"Rs. " +
                  (
                    userInformation[0]?.loan_application
                      ?.preferred_loan_amount || 0
                  ).toLocaleString("en-US", {
                    maximumFractionDigits: 0,
                  }) +
                  "/-"}
              </Label>
            </ModalBody>
            <ModalFooter>
              <p>Are you sure?</p>
              <Button color="primary" onClick={approve}>
                Approve
              </Button>{" "}
              <Button color="secondary" onClick={toggleApprove}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>

          {/* Modal for reject Application */}
          <Modal isOpen={rejectModal} toggle={toggleReject}>
            <ModalHeader toggle={toggleReject}>Reject Application</ModalHeader>

            {/* <ModalBody>
<label htmlFor="rejectComment">Reason for Rejection : </label>
<input
type="text"
id="rejectComment"
placeholder="Enter comments..."
value={rejectComment}
onChange={(e) => setRejectComment(e.target.value)}
style={{ marginLeft: "10px" }}
/>
</ModalBody> */}
            <ModalFooter>
              <p>Are you sure? </p>
              <Button color="danger" onClick={reject}>
                Reject
              </Button>{" "}
              <Button color="secondary" onClick={toggleReject}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
          <Modal isOpen={reviewModal} toggle={toggleReview}>
            <ModalHeader toggle={toggleReview}>
              Under Review Application
            </ModalHeader>
            <ModalFooter>
              <p>Are you sure? </p>
              <Button color="info" onClick={underReview}>
                Under Review
              </Button>{" "}
              <Button color="secondary" onClick={toggleReview}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>

          {/* Modals for the score Criterias */}
          <FarmerProfileModal
            modal={modalCriteria.criteriaName === "Farmer Profile"}
            toggleCriteria={toggleCriteria}
          />
          <StaticaDataModal
            modal={modalCriteria.criteriaName === "Static Data"}
            toggleCriteria={toggleCriteria}
          />
          <GovtDataModal
            modal={modalCriteria.criteriaName === "Govt. Data"}
            toggleCriteria={toggleCriteria}
          />
          <AgronomicsModal
            modal={modalCriteria.criteriaName === "Agronomics"}
            toggleCriteria={toggleCriteria}
          />
          <CropSaleModal
            modal={modalCriteria.criteriaName === "Crop Sale"}
            toggleCriteria={toggleCriteria}
          />
          <CropInsuranceData
            modal={modalCriteria.criteriaName === "Crop Insurance Data"}
            toggleCriteria={toggleCriteria}
          />
          <SocialDataModal
            modal={modalCriteria.criteriaName === "Social Data"}
            toggleCriteria={toggleCriteria}
          />
          {/* <MDBCard className="mb-4">
<MDBCardBody> */}
          {!isLoading ? (
            <div className="text-center">
              <Spinner className="mr-2" color="primary"></Spinner>
            </div>
          ) : (
            <>
              <div className="align-items-end ml-3 d-flex mb-3 justify-content-between">
                <h4
                  style={{
                    fontWeight: "600",
                  }}
                >
                  User Information
                </h4>
                {bankAdmin &&
                  +userInformation[0]?.loan_application?.loan_status === 1 && (
                    <div className="align-items-end d-flex justify-content-end mb-4">
                      <Button
                        className="mr-1"
                        color="none"
                        style={{
                          background: "#e4f7f1",
                          color: "rgb(00, 100, 0)",
                          padding: "10px",
                          fontSize: "0.8rem",
                        }}
                        onClick={toggleApprove}
                        value={2}
                        disabled={isDisable}
                      >
                        Approve
                      </Button>
                      <Button
                        className="mr-1"
                        color="none"
                        style={{
                          background: "rgb(200, 230, 255)",
                          color: "rgb(60, 80, 120)",
                          padding: "10px",
                          fontSize: "0.8rem",
                        }}
                        onClick={toggleReview}
                        value={3}
                      >
                        Under Review
                      </Button>
                      <Button
                        color="none"
                        style={{
                          background: "rgb(251,231,233)",
                          color: "rgb(224,109,110)",
                          padding: "10px",
                          fontSize: "0.8rem",
                        }}
                        onClick={toggleReject}
                        value={-2}
                      >
                        Reject
                      </Button>
                    </div>
                  )}
                {bankAdmin &&
                  +userInformation[0]?.loan_application?.loan_status === 3 && (
                    <div className="align-items-end d-flex justify-content-end mb-4">
                      <Button
                        className="mr-1"
                        color="none"
                        style={{
                          background: "#e4f7f1",
                          color: "rgb(00, 100, 0)",
                          padding: "10px",
                          fontSize: "0.8rem",
                        }}
                        onClick={toggleApprove}
                        value={2}
                        disabled={isDisable}
                      >
                        Approve
                      </Button>
                      <Button
                        color="none"
                        style={{
                          background: "rgb(251,231,233)",
                          color: "rgb(224,109,110)",
                          padding: "10px",
                          fontSize: "0.8rem",
                        }}
                        onClick={toggleReject}
                        value={-2}
                      >
                        Reject
                      </Button>
                    </div>
                  )}
              </div>

              {userLoading ? (
                <div className="text-center">
                  <Spinner className="mr-2 mb-4" color="primary"></Spinner>
                </div>
              ) : (
                <div
                  className="justify-content-center d-flex mb-3"
                  id="forGalaxyfold"
                >
                  <Col xl={12}>
                    <Row>
                      {/* <Col xl={6}>
                        <Card style={{ borderRadius: "20px" }}>
                          <CardBody>
                            <Card style={{ borderRadius: "10px" }}>
                              <CardBody
                                style={{
                                  minHeight: "280px",
                                  border: "1px #ced4da solid",
                                  borderRadius: "10px",
                                  justifyContent: "center",
                                  marginTop: "20px",
                                  padding: "30px",
                                }}
                              >
                                <h2
                                  style={{
                                    fontWeight: "600",
                                    marginBottom: "30px",
                                  }}
                                >
                                  Applicant Information
                                </h2>
                                <Row className="mb-3">
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "100px",
                                      }}
                                    >
                                      User Name
                                    </h6>
                                    <Input
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      value={
                                        userInformation[0]?.user_data?.name
                                      }
                                      disabled
                                    />
                                  </Col>
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "100px",
                                      }}
                                    >
                                      District
                                    </h6>
                                    <Input
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      value={
                                        userInformation[0]?.user_data?.district
                                      }
                                      disabled
                                    />
                                  </Col>
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "100px",
                                      }}
                                    >
                                      Cnic
                                    </h6>
                                    <Input
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      value={
                                        userInformation[0]?.loan_application
                                          ?.cnic
                                      }
                                      disabled
                                    />
                                  </Col>
                                </Row>
                                <Row className="mb-3">
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "100px",
                                      }}
                                    >
                                      Land Size
                                    </h6>
                                    <Input
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      value={
                                        userInformation[0]?.loan_application
                                          ?.land_size_acres +
                                        (userInformation[0]?.loan_application
                                          ?.land_size_acres === 1
                                          ? " Acre"
                                          : isNaN(
                                              userInformation[0]
                                                ?.loan_application
                                                ?.land_size_acres
                                            )
                                          ? ""
                                          : " Acres")
                                      }
                                      disabled
                                    />
                                  </Col>
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "100px",
                                      }}
                                    >
                                      Land Status
                                    </h6>
                                    <Input
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      value={
                                        userInformation[0]?.loan_application
                                          ?.land_ownership
                                      }
                                      disabled
                                    />
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </CardBody>
                        </Card>
                      </Col> */}
                      <Col xl={6}>
                        <Card style={{ borderRadius: "20px" }}>
                          <CardBody>
                            <Card style={{ borderRadius: "10px" }}>
                              <CardBody
                                style={{
                                  minHeight: "300px",
                                  border: "1px #ced4da solid",
                                  borderRadius: "10px",
                                  marginTop: "20px",
                                  padding: "22px",
                                }}
                              >
                                <h2
                                  style={{
                                    fontWeight: "600",
                                    marginBottom: "30px",
                                  }}
                                >
                                  Applicant Information
                                </h2>
                                <Row className="mb-3">
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "100px",
                                      }}
                                    >
                                      User Name
                                    </h6>
                                    <Input
                                      value={
                                        userInformation[0]?.user_data?.name
                                      }
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                    ></Input>
                                  </Col>
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "200px",
                                      }}
                                    >
                                      District
                                    </h6>
                                    <Input
                                      value={
                                        userInformation[0]?.user_data?.district
                                      }
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      disabled
                                    ></Input>
                                  </Col>
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "200px",
                                      }}
                                      disabled
                                    >
                                      Cnic
                                    </h6>
                                    <Input
                                      value={
                                        userInformation[0]?.loan_application
                                          ?.cnic
                                      }
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      disabled
                                    ></Input>
                                  </Col>
                                </Row>
                                <Row className="mb-3">
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "300px",
                                      }}
                                      disabled
                                    >
                                      Land Size
                                    </h6>
                                    <Input
                                      value={
                                        userInformation[0]?.loan_application
                                          ?.land_size_acres +
                                        (userInformation[0]?.loan_application
                                          ?.land_size_acres === 1
                                          ? " Acre"
                                          : isNaN(
                                              userInformation[0]
                                                ?.loan_application
                                                ?.land_size_acres
                                            )
                                          ? ""
                                          : " Acres")
                                      }
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      disabled
                                    ></Input>
                                  </Col>
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "300px",
                                      }}
                                    >
                                      Land Status
                                    </h6>
                                    <Input
                                      value={
                                        userInformation[0]?.loan_application
                                          ?.land_ownership
                                      }
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      disabled
                                    ></Input>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </CardBody>
                        </Card>
                      </Col>

                      <Col xl={6}>
                        <Card style={{ borderRadius: "20px" }}>
                          <CardBody>
                            <Card style={{ borderRadius: "10px" }}>
                              <CardBody
                                style={{
                                  minHeight: "300px",
                                  border: "1px #ced4da solid",
                                  borderRadius: "10px",
                                  marginTop: "20px",
                                  padding: "22px",
                                }}
                              >
                                <h2
                                  style={{
                                    fontWeight: "600",
                                    marginBottom: "30px",
                                  }}
                                >
                                  Loan Details
                                </h2>
                                <Row className="mb-3">
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "100px",
                                      }}
                                    >
                                      Loan Id
                                    </h6>
                                    <Input
                                      value={
                                        userInformation[0]?.loan_application
                                          ?.loan_id
                                      }
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                    ></Input>
                                  </Col>
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "200px",
                                      }}
                                    >
                                      Required Fertilizer Quantity
                                    </h6>
                                    <Input
                                      value={`${userInformation[0]?.loan_application?.required_dap_quantity} DAP & ${userInformation[0]?.loan_application?.required_urea_quantity} Urea`}
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      disabled
                                    ></Input>
                                  </Col>
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "200px",
                                      }}
                                      disabled
                                    >
                                      Required Seeds Quantity
                                    </h6>
                                    <Input
                                      value={`${userInformation[0]?.loan_application?.required_seeds_quantity_kgs} KG`}
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      disabled
                                    ></Input>
                                  </Col>
                                </Row>
                                <Row className="mb-3">
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "300px",
                                      }}
                                      disabled
                                    >
                                      Required Pesticides Quantity
                                    </h6>
                                    <Input
                                      value={
                                        userInformation[0]?.loan_application
                                          ?.required_pesticides_quantity +
                                        (userInformation[0]?.loan_application
                                          ?.required_pesticides_quantity === "1"
                                          ? " Liter"
                                          : isNaN(
                                              +userInformation[0]
                                                ?.loan_application
                                                ?.required_pesticides_quantity
                                            )
                                          ? ""
                                          : " Liters")
                                      }
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      disabled
                                    ></Input>
                                  </Col>
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "300px",
                                      }}
                                    >
                                      Desired Crop
                                    </h6>
                                    <Input
                                      value={
                                        userInformation[0]?.loan_application
                                          ?.desired_crop
                                      }
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      disabled
                                    ></Input>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Card style={{ borderRadius: "20px" }}>
                          <CardBody>
                            <Card>
                              <CardBody
                                style={{
                                  minHeight: "300px",
                                  border: "1px #ced4da solid",
                                  borderRadius: "10px",
                                  marginTop: "20px",
                                  padding: "20px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <h2
                                    style={{
                                      fontWeight: "600",
                                      marginBottom: "30px",
                                    }}
                                  >
                                    Loan Assessment
                                  </h2>
                                  <div style={{ display: "flex" }}>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        marginRight: "5px",
                                      }}
                                    >
                                      Date:
                                    </h6>
                                    <h6 style={{ opacity: "50%" }}>
                                      {moment(
                                        userInformation[0]?.loan_application
                                          ?.createdAt
                                      ).format("DD-MM-YYYY")}
                                    </h6>
                                  </div>
                                </div>
                                <Row className="mb-3">
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "200px",
                                      }}
                                    >
                                      Maximum Attainable Score
                                    </h6>
                                    <Input
                                      value={148}
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      disabled
                                    ></Input>
                                  </Col>
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "200px",
                                      }}
                                    >
                                      Score Achieved
                                    </h6>
                                    <Input
                                      value={
                                        userInformation[0]?.loan_application
                                          ?.loan_score
                                      }
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      disabled
                                    ></Input>
                                  </Col>
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "200px",
                                      }}
                                    >
                                      Credit Score Grade
                                    </h6>
                                    <Input
                                      value={
                                        userInformation[0]?.loan_application
                                          ?.loan_grade
                                      }
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      disabled
                                    ></Input>
                                  </Col>
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "200px",
                                      }}
                                    >
                                      Loan Amount
                                    </h6>
                                    <Input
                                      value={
                                        "Rs. " +
                                        (
                                          userInformation[0]?.loan_application
                                            ?.preferred_loan_amount || 0
                                        ).toLocaleString("en-US", {
                                          maximumFractionDigits: 0,
                                        }) +
                                        "/-"
                                      }
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      disabled
                                    ></Input>
                                  </Col>
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "200px",
                                      }}
                                    >
                                      Loan Status
                                    </h6>
                                    <Input
                                      value={
                                        loanStatus[
                                          +userInformation[0]?.loan_application
                                            ?.loan_status + 2
                                        ]
                                      }
                                      style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                      }}
                                      disabled
                                    ></Input>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <h6
                                      style={{
                                        fontWeight: "600",
                                        width: "200px",
                                      }}
                                    >
                                      Comments*
                                    </h6>
                                    {!bankAdmin && (
                                      <Input
                                        value={
                                          userInformation[0]?.loan_application
                                            ?.comment
                                        }
                                        style={{
                                          height: "45px",
                                          borderRadius: "8px",
                                          color: "red",
                                          fontWeight: "bolder",
                                        }}
                                        disabled
                                      ></Input>
                                    )}
                                    {bankAdmin &&
                                      +userInformation[0]?.loan_application
                                        ?.loan_status === 2 && (
                                        <Input
                                          value={
                                            userInformation[0]?.loan_application
                                              ?.comment
                                          }
                                          style={{
                                            height: "45px",
                                            borderRadius: "8px",
                                            color: "red",
                                            fontWeight: "bolder",
                                          }}
                                          disabled
                                        ></Input>
                                      )}
                                    {bankAdmin &&
                                      +userInformation[0]?.loan_application
                                        ?.loan_status === -2 && (
                                        <Input
                                          value={
                                            userInformation[0]?.loan_application
                                              ?.comment
                                          }
                                          style={{
                                            height: "45px",
                                            borderRadius: "8px",
                                            color: "red",
                                            fontWeight: "bolder",
                                          }}
                                          disabled
                                        ></Input>
                                      )}
                                    {bankAdmin &&
                                      +userInformation[0]?.loan_application
                                        ?.loan_status === 1 && (
                                        <div
                                          style={{
                                            position: "relative",
                                            // width: "300px",
                                            height: "100px",
                                            marginTop: "20px",
                                          }}
                                        >
                                          <Input
                                            id="Comment"
                                            value={comment}
                                            placeholder="Comments"
                                            onChange={(e) =>
                                              setComment(e.target.value)
                                            }
                                            style={{
                                              height: "45px",
                                              borderRadius: "8px",
                                              width: "100%",
                                            }}
                                          ></Input>
                                          <div>
                                            <FormGroup check>
                                              <Input
                                                id="exampleCheck"
                                                name="check"
                                                type="checkbox"
                                                onClick={handleDisable}
                                              />
                                              <Label check for="exampleCheck">
                                                ECIB Verified
                                              </Label>
                                            </FormGroup>
                                          </div>
                                        </div>
                                      )}

                                    {bankAdmin &&
                                      +userInformation[0]?.loan_application
                                        ?.loan_status === 3 && (
                                        <div
                                          style={{
                                            position: "relative",
                                            // width: "300px",
                                            height: "100px",
                                            marginTop: "20px",
                                          }}
                                        >
                                          <Input
                                            id="Comment"
                                            value={comment}
                                            placeholder="Comments"
                                            onChange={(e) =>
                                              setComment(e.target.value)
                                            }
                                            style={{
                                              height: "45px",
                                              borderRadius: "8px",
                                              width: "100%",
                                            }}
                                          ></Input>
                                          <div>
                                            <FormGroup check>
                                              <Input
                                                id="exampleCheck"
                                                name="check"
                                                type="checkbox"
                                                onClick={handleDisable}
                                              />
                                              <Label check for="exampleCheck">
                                                ECIB Verified
                                              </Label>
                                            </FormGroup>
                                          </div>
                                        </div>
                                      )}
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Col>

                  {/* <MDBTable>
<MDBTableBody>
<tr>
<td className="tb-bold">User Name</td>
<td>{userInformation[0]?.user_data?.name}</td>
</tr>
<tr>
<td className="tb-bold">District</td>
<td>{userInformation[0]?.user_data?.district}</td>
</tr>
<tr>
<td className="tb-bold">CNIC</td>
<td>
{userInformation[0]?.loan_application?.cnic}
</td>
</tr>
<tr>
<td className="tb-bold">Land status</td>
<td>
{
userInformation[0]?.loan_application
?.land_ownership
}
</td>
</tr>
<tr>
<td className="tb-bold">Land size</td>
<td>
{
userInformation[0]?.loan_application
?.land_size_acres
}
{+userInformation[0]?.loan_application
?.land_size_acres === 1
? " Acre"
: isNaN(
+userInformation[0]?.loan_application
?.land_size_acres
)
? ""
: " Acres"}
</td>
</tr>
</MDBTableBody>
</MDBTable> */}

                  {/* <MDBTable>
<MDBTableBody>
<tr>
<td className="tb-bold">Loan Id</td>
<td>
{userInformation[0]?.loan_application?.loan_id}
</td>
</tr>
<tr>
<td className="tb-bold">
Required Fertilizer Quantity
</td>
<td>{`${userInformation[0]?.loan_application?.required_dap_quantity} DAP & ${userInformation[0]?.loan_application?.required_urea_quantity} Urea`}</td>
</tr>
<tr>
<td className="tb-bold">Required Seeds Quantity</td>
<td>{`${userInformation[0]?.loan_application?.required_seeds_quantity_kgs} KG`}</td>
</tr>
<tr>
<td className="tb-bold">
Required Pesticides Quantity
</td>
<td>
{
userInformation[0]?.loan_application
?.required_pesticides_quantity
}
{userInformation[0]?.loan_application
?.required_pesticides_quantity === "1"
? " Liter"
: isNaN(
+userInformation[0]?.loan_application
?.required_pesticides_quantity
)
? ""
: " Liters"}
</td>
</tr>
<tr>
<td className="tb-bold">Desired Crop</td>
<td>
{
userInformation[0]?.loan_application
?.desired_crop
}
</td>
</tr>
</MDBTableBody>
</MDBTable> */}

                  {/*<MDBTable>
<MDBTableBody>*/}
                  {/* Table Row 1: Date */}
                  {/*<tr>
<td className="tb-bold">Date</td>
<td>
{moment(
userInformation[0]?.loan_application?.createdAt
).format("DD-MM-YYYY")}
</td>
</tr>*/}

                  {/* Table Row 2: Maximum Attainable Score */}
                  {/*<tr>
<td className="tb-bold">
Maximum Attainable Score
</td>
<td>148</td>
</tr>*/}

                  {/* Table Row 3: Score Achieved */}
                  {/*<tr>
<td className="tb-bold">Score Achieved</td>
<td>
{userInformation[0]?.loan_application?.loan_score}
</td>
</tr>*/}

                  {/* Table Row 4: Credit Score Grade */}
                  {/*<tr>
<td className="tb-bold">Credit Score Grade</td>
<td>
{userInformation[0]?.loan_application?.loan_grade}
</td>
</tr>*/}

                  {/* Table Row 5: Loan Amount */}
                  {/*<tr>
<td className="tb-bold">Loan Amount</td>
<td>
{"Rs. " +
(
userInformation[0]?.loan_application
?.preferred_loan_amount || 0
).toLocaleString("en-US", {
maximumFractionDigits: 0,
}) +
"/-"}
</td>
</tr>*/}

                  {/* Table Row 6: Loan status */}
                  {/*<tr>*/}
                  {/*<div>*/}
                  {/*<td className="tb-bold">Loan status</td>*/}
                  {/*</div>*/}

                  {/*<td>*/}
                  {/*{*/}
                  {/* loanStatus[
+userInformation[0]?.loan_application
?.loan_status + 2
] */}
                  {/* } */}

                  {/*{bankAdmin && (*/}
                  {/*<div>*/}
                  {/*<FormGroup check>*/}
                  {/*<Input*/}
                  {/*id="exampleCheck"*/}
                  {/*name="check"*/}
                  {/*type="checkbox"*/}
                  {/*onClick={handleDisable}*/}
                  {/*/>*/}
                  {/*<Label check for="exampleCheck">*/}
                  {/*ECIB Verified*/}
                  {/*</Label>*/}
                  {/*</FormGroup>*/}
                  {/*</div>*/}
                  {/**/}

                  {/*{bankAdmin && (*/}
                  {/*<div*/}
                  {/*style={{*/}
                  {/*position: "relative",*/}
                  {/*width: "300px",*/}
                  {/*height: "100px",*/}
                  {/*marginTop: "20px",*/}
                  {/*}}*/}
                  {/*>*/}
                  {/*<label htmlFor="Comment">Comments</label>*/}
                  {/*<textarea*/}
                  {/*id="Comment"*/}
                  {/*value={comment}*/}
                  {/*placeholder="Comments"*/}
                  {/*onChange={(e) => setComment(e.target.value)}*/}
                  {/*style={{*/}
                  {/*width: "100%",*/}
                  {/*height: "100%",*/}
                  {/*}}*/}
                  {/*/>*/}
                  {/*</div>*/}
                  {/*)}*/}
                  {/*</td>*/}
                  {/*</tr>*/}

                  {/* Table Row 7: Empty */}
                  {/*<tr>*/}
                  {/*<td></td>*/}
                  {/*<td></td>*/}
                  {/*</tr>*/}

                  {/*</MDBTableBody>*/}
                  {/*</MDBTable>*/}
                </div>
              )}

              {/* -------------------------atique----------------------------------- */}
              {/*
{!bankAdmin && (
// ---------------- ye logic lagae he----------------
// userInformation[0]?.loan_application?.comment !== null &&
// userInformation[0]?.loan_application?.comment.trim() !==
// "" &&
<>
<Link
to={
{
// pathname: `/loan-financials/${x?.loan_application?.loan_id}/${x?.loan_application?._id}`,
}
}
onClick={() => {
toggleModal();
setModalComment(
userInformation[0]?.loan_application?.comment
);
}}
className="waves-effect waves-light mr-1 "
position="absolute"
color="primary"
style={{
display: "flex",
justifyContent: "flex-end",
marginTop: "-45px",
}}
>
View Comments
</Link>

{/* Modal for comments */}
              {/*<Modal isOpen={modalIsOpen} toggle={toggleModal}>
<ModalHeader toggle={toggleModal}>Comments</ModalHeader>
<ModalBody>
<label htmlFor="Comment"></label>
<div
style={{
position: "relative",
width: "450px",
height: "110px",
border: "1px solid #ced4da",
borderRadius: "5px",
}}
>
<div
id="Comment"
// key={index}
style={{
width: "100%",
height: "100%",
boxSizing: "border-box",
padding: "8px",
overflowY: "auto",
}}
>
{modalComment ? modalComment : "N/A"}
</div>

{/* <div
style={{
position: "absolute",
top: "8px",
left: "8px",
pointerEvents: "none",
color: "gray",
}}
>
ye disabled he
</div> */}
              {/*</div>
</ModalBody>
</Modal>*/}
              {/*</>
)}
*/}

              {/* {console.log("type bhi he",loanId, typeof loanId)} */}

              {!bankAdmin && (
                <div className="d-flex flex-wrap ml-3 justify-content-between mb-3">
                  <div>
                    <h4 style={{ fontWeight: "600" }}>Credit Score</h4>
                  </div>

                  <div
                    style={{
                      maxWidth: "900px",
                      display: "flex",
                      flexWrap: "wrap",
                    }}
                  >
                    {analytics["loan_score_data"] &&
                      Object.keys(analytics["loan_score_data"]).map((x, i) => (
                        <Button
                          key={i}
                          className="mr-3 mb-3" // Added mb-3 for bottom margin
                          style={{ borderRadius: "7px", height: "40px" }}
                          outline
                          onClick={() => scrollToTable(x)}
                        >
                          {x}
                        </Button>
                      ))}
                  </div>
                </div>
              )}

              {/* <div className='d-flex justify-content-end mr-4'> */}
              {/* </div> */}
              {!bankAdmin &&
                analytics &&
                Object.keys(analytics["loan_score_data"]).map((x) => {
                  return (
                    <>
                      <MDBCard style={{ borderRadius: "20px" }}>
                        <MDBCardBody>
                          <h5
                            style={{ fontWeight: "700", marginBottom: "20px" }}
                          >
                            {x}{" "}
                            <span
                              style={{
                                textDecoration: "underline",
                                fontSize: "0.9rem",
                                fontWeight: "400",
                                marginLeft: "8px",
                                color: "#0000ee",
                                cursor: "pointer",
                              }}
                              // style={{ boxShadow: 'none', borderBottom:'2px solid blue', fontSize: '1.3rem', color:'blue', marginLeft:'10px', cursor: 'pointer' }}
                              onClick={() => toggleCriteria(x)}
                            >
                              View Criteria
                            </span>
                          </h5>
                          <div className="rounded">
                            {userLoading ? (
                              <div className="text-center">
                                <Spinner
                                  className="mr-2"
                                  color="primary"
                                ></Spinner>
                              </div>
                            ) : (
                              <Table
                                className="table table-bordered"
                                responsive
                              >
                                <MDBTableHead color="primary-color">
                                  <tr>
                                    <th
                                      style={{
                                        fontSize: "1rem",
                                        backgroundColor: "#f6fbfd",
                                      }}
                                    >
                                      Item
                                    </th>
                                    <th
                                      style={{
                                        fontSize: "1rem",
                                        backgroundColor: "#f6fbfd",
                                      }}
                                    >
                                      Criteria
                                    </th>
                                    <th
                                      style={{
                                        fontSize: "1rem",
                                        backgroundColor: "#f6fbfd",
                                      }}
                                    >
                                      Score
                                    </th>
                                  </tr>
                                </MDBTableHead>
                                {analytics["loan_score_data"] &&
                                  Object.keys(
                                    analytics["loan_score_data"][x]
                                  ).map(
                                    (y) => {
                                      // EDITED BY

                                      // const entryField = analytics["loan_score_data"][x][y]?.criteria;
                                      // if (entryField) {

                                      // console.log(Object.keys(x)[0].split('_').map(x => x.charAt(0).toUpperCase() + x.substring(1)).join(' '))
                                      // console.log({y})

                                      return (
                                        <MDBTableBody id={`table_${x}`}>
                                          <tr>
                                            <td style={{}}>
                                              {y
                                                .split("_")
                                                .map(
                                                  (x) =>
                                                    x.charAt(0).toUpperCase() +
                                                    x.substring(1)
                                                )
                                                .join(" ")}
                                            </td>
                                            <td
                                              style={{ width: "35%" }}
                                              className="tooltip-container"
                                            
                                            >
                                              <div
                                            
                                              style={{ cursor: y === "gender" ? "pointer" : "auto" }}
                                                onClick={() => {
                                                  console.log(y === "gender")
                                                  if (y === "gender") {
                                                    history.push(
                                                      `/master-data/${loan.cnic}`
                                                    );
                                                  }
                                                }}
                                              >
                                                <span
                                                  data-tip={`${
                                                    analytics[
                                                      "loan_score_data"
                                                    ][x][y].extra_details?.key
                                                      ? `${
                                                          analytics[
                                                            "loan_score_data"
                                                          ][x][y]?.extra_details
                                                            ?.key
                                                        } 
(${
                                                          analytics[
                                                            "loan_score_data"
                                                          ][x][y]?.extra_details
                                                            ?.value
                                                            ? analytics[
                                                                "loan_score_data"
                                                              ][x][
                                                                y
                                                              ]?.extra_details?.value
                                                                ?.toString()
                                                                ?.split(",")
                                                                ?.join(", ")
                                                            : "Not available"
                                                        })`
                                                      : ""
                                                  }`}
                                                >
                                                  {isNaN(
                                                    +analytics[
                                                      "loan_score_data"
                                                    ][x][y]?.criteria
                                                  )
                                                    ? analytics[
                                                        "loan_score_data"
                                                      ][x][y]?.criteria
                                                        .split("_")
                                                        .map(
                                                          (x) =>
                                                            x
                                                              .charAt(0)
                                                              .toUpperCase() +
                                                            x.substring(1)
                                                        )
                                                        .join(" ")
                                                    : analytics[
                                                        "loan_score_data"
                                                      ][x][y]?.criteria}
                                                </span>
                                              </div>
                                              {analytics["loan_score_data"][x][
                                                y
                                              ].extra_details ? (
                                                <ReactTooltip
                                                  place="top"
                                                  type="info"
                                                  effect="solid"
                                                />
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td style={{ width: "20%" }}>
                                              {
                                                analytics["loan_score_data"][x][
                                                  y
                                                ]?.score
                                              }
                                            </td>
                                          </tr>
                                        </MDBTableBody>
                                      );
                                    }
                                    // }
                                  )}
                              </Table>
                            )}
                          </div>
                        </MDBCardBody>
                      </MDBCard>
                    </>
                  );
                })}
            </>
          )}
          {/* </MDBCardBody>
</MDBCard> */}
        </div>
      </Container>
    </React.Fragment>
    // <div>text</div>
  );
}

export default LoanAnalytics;
